<template>
    <div>
        <div class="show-destop">
            <link rel="stylesheet" href="/themes/web/assets/css/auth.css?v=3">
            <nav-bar-auth/>
            <div class="modal fade" id="languageModal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="languageModal" aria-hidden="true">
                <div class="modal-dialog" style="width: 264px; max-height: 216px; padding-top: calc(50vh - 100px)">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title">{{ $t('choose_language') }}</h5>
                            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div class="modal-body">
                            <ul class="languages">
                                <li :class="locate == localize.lang?'active':''" @click="setLocate(localize)" v-for="(localize, index) in configs.localize">
                                    <div class="flag">
                                        <img :src="localize.img_flag" alt="">
                                    </div>
                                    <div class="title">{{ $t(localize.lang) }}</div>
                                    <i class="lisa-icon-checked-1"></i>
                                </li>
                            </ul>
                        </div>
                        <div class="modal-footer">
                            <button type="button" @click="updateLocate()" class="lisa-btn-fit active">{{ $t('confirm') }}</button>
                        </div>
                    </div>
                </div>
            </div>
            <div id="wrapper" class="wrapper d-flex align-items-stretch"
            v-bind:style="configs.themes?.login_background_url ? { 'background-image': 'url(' + configs.themes?.login_background_url + ')' } : ''">
                <!-- <div id="left-corner" class="left-corner" v-bind:style="{ content: 'url(' + configs.themes?.left_content + ')' }" v-if="configs.themes?.left_content">
                </div>
                <div id="right-corner" class="right-corner" v-bind:style="{ content: 'url(' + configs.themes?.right_content + ')' }" v-if="configs.themes?.right_content">
                </div> -->
                <div id="left-corner" class="left-corner"> </div>
                <div id="right-corner" class="right-corner"> </div>
                <div id="content">
                    <div class="container">
                        <router-view></router-view>
                    </div>
                </div>
            </div>
            <footer-element/>            
        </div>
        <mobile-download-app/>  

        <div class="loading" id="loading" v-if="isLoading">
            <img class="spinner" src="/themes/ito/images/loadding.png" alt=""/>
        </div>

    </div>
</template>

<script>
    import SideBar from "../SideBar";
    import FooterElement from "../FooterElement";
    import NavBarAuth from "../NavBarAuth";
    import {getConfigs, getLanguage, soundClick} from "../../utils/utils";
    import {updateLanguage} from '../../models/profile';
    import MobileDownloadApp from '../element/MobileDownloadApp.vue';

    export default {
        name: "AuthLayout",
        data() {
            const grade_default = localStorage.getItem('grade');
            const configs = this.$store.getters.configs;
            //const configs = getConfigs();
            //const localizes = configs.localize || [];

            console.log(configs)

            return {
                locate: getLanguage(),
                locate_obj: null,
                user: {
                    grade: 1
                },
                grade_selected: grade_default || 1,
                placement_test: {
                    id: 0,
                    condition_pass: 0,
                    time: 0,
                    total_question: 0,
                },
                //configs: configs,
                localizes: configs?configs.localize:[],
            };
        },

        components: {
            NavBarAuth,
            FooterElement,
            SideBar,
            MobileDownloadApp
        },

        computed: {
            isLoading() {
                return this.$store.getters.isLoading
            },
            configs() {
                const configs = this.$store.getters.configs;
                if(configs){
                    return configs;
                }

                return {
                    localize: []
                }
            },
        },

        methods: {
            getSoundClick() {
                soundClick();
            },

            setLocate(e) {
                this.getSoundClick();

                this.locate_obj = e;
                this.locate = e.lang;

                //localStorage.setItem('lang', e);
            },

            updateLocate() {
                const that = this;

                this.getSoundClick();

                localStorage.setItem('lang', this.locate);

                if (that.locate_obj != null) {
                    that.$store.commit("setLoading", true);

                    updateLanguage({
                        id: that.locate_obj.id,
                        is_raw: true
                    }).then((response) => {
                        that.$store.commit("setLoading", false);

                        if (response.data.code != 0) {
                            return;
                        }
                    }).catch(({response}) => {
                        that.$store.commit("setLoading", false);

                        console.error(response);
                    });
                }

                location.reload();
            }
        }

    }
</script>
<style scoped>
    #languageModal .modal-title{
        font-weight: 700;
        font-size: 18px;
        color: #000000;
        margin-bottom: 10px;
    }
    #languageModal .modal-header{
        padding: 0;
        margin-top: 15px;
    }
    #languageModal .modal-content{
        /* padding: 0; */
    }

    #languageModal .modal-footer{
        padding-bottom: 20px;
    }

    .btn-close{
        margin: -3px -5px -8px 0;
    }
    .left-corner {
        position: fixed;
        width: 13vw;
        max-width: 250px;
        z-index: 2;
        top: 165px;
        left: 50px;
        animation: 1s ease-out 0s 1 slideInFromLeft, 3s ease-in-out 1s infinite floating;
        content: var(--left-corner-image);
    }


    .right-corner {
        position: fixed;
        width: 13vw;
        max-width: 200px;
        top: 115px;
        right: 50px;
        animation: 1s ease-out 0s 1 slideInFromRight;
        content: var(--right-corner-image);
    }
    .left-corner.hide{
        transition: all 1s ease-out;
        left: -100%;
    }
    .right-corner.hide{
        transition: all 1s ease-out;
        right: -100%;
    }

    @keyframes slideInFromLeft {
        0% {
            transform: translateX(-100%);
        }

        100% {
            transform: translateX(0);
        }
    }
    @keyframes slideOutToLeft {
        0% {
            transform: translateX(0);
        }

        100% {
            transform: translateX(-100%);
        }
    }

    @keyframes slideInFromRight {
        0% {
            transform: translateX(100%);
        }

        100% {
            transform: translateX(0);
        }
    }
    @keyframes floating {
        from {
            transform: translate(0, 0px);
        }

        65% {
            transform: translate(0, 15px);
        }

        to {
            transform: translate(0px, 0px);
        }
    }
    .wrapper{
    background-repeat: no-repeat;
    background-position: center center;
    background-size: cover;
    font-family: "Nunito",
    }
</style>